import { format } from "date-fns";

import { mapperIvf } from "@app/statefx/routines/mapperfn-invoice";
import {
  epBuilderAll,
  epBuilderAnyIssuerNoSlices,
} from "@app/statefx/routines/mapperfn-pathbuilder";
import {
  TBlueObj,
  TBlueTable,
  TDBReceiptFiscal,
  TIvFiscal,
} from "@app/types/insider";

const REPO_OAUTH2 = "OAuth2Status";
type TRepoOAuth2 = {
  tokenIsDefined: boolean;
  expireDate?: string;
};

export const OAuth2Status: TBlueObj<TRepoOAuth2> = {
  name: REPO_OAUTH2,
  initialState: {
    tokenIsDefined: false,
    expireDate: null,
  } as TRepoOAuth2,
  starfx: true,
  idb: false,
  bootPriority: 0,
};
export const invoiceFiscal: TBlueTable<TIvFiscal> = {
  name: "invoiceFiscal",
  empty: {} as TIvFiscal,
  initialState: {},
  apiUrl: "/select/ss_listOf_invoice_range",
  pkeyUrl: "/select/ss_listOf_invoice_range_pkey",
  urlPathBuilder: epBuilderAll,
  primaryKey: "FF_ID",
  starfx: true,
  starfx_index: "FF_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "ivByDate", keyPath: "LA_DATA" },
    { name: "ivByIssuerPrefix", keyPath: "ABR" },
    { name: "ivByDateAndIssuer", keyPath: ["ABR", "LA_DATA"] },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  mapWrite: "invoiceFiscal",
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Facturi fiscale",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const receiptFiscal: TBlueTable<TDBReceiptFiscal> = {
  name: "receiptFiscal",
  empty: {} as TDBReceiptFiscal,
  initialState: {},
  apiUrl: "/select/ss_receipts",
  pkeyUrl: null,
  primaryKey: "ID_CHITANTA",
  starfx: true,
  starfx_index: "ID_CHITANTA",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    // { name: 'shid0', keyPath: 'shid0' },
    // { name: 'rcByDate', keyPath: 'LA_DATA' },
    // { name: 'rcByIssuerPrefix', keyPath: 'ABR' },
    // { name: 'rcByDateAndIssuer', keyPath: ['ABR', 'LA_DATA'] },
  ],
  mapWrite: (item) => {
    item.LA_DATA_FMT = format(new Date(item.DATA), "yyyy-MM-dd");
    return item;
  },
  urlPathBuilder: epBuilderAnyIssuerNoSlices,
  bootPriority: 1,
  onmru: "new",
  oncsdb: "full",
  label: "Chitante",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};
